import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import BranchService from '../../services/branch/BranchService';
import { loadingBranchDropdown, loadingMyBranch } from '../../store/slices/branches/branchSlice';

export const useBranch = () => {
  const dispatch: AppDispatch = useDispatch();

  const { branchDropdown, myBranch } = useSelector((state: RootState) => state.branch);

  /**
   * 🔹 Cargar TODAS las sucursales activas
   */
  const fetchBranchDropdown = async () => {
    try {
      const response = await BranchService.fetchDropdown();
      dispatch(loadingBranchDropdown(response));
    } catch (error) {
      console.error('Error al cargar sucursales:', error);
    }
  };

  /**
   * 🔹 Cargar SOLO sucursales válidas para VENTAS
   *    (Sucursal 01, Casa Matriz 02)
   */
  const fetchSalesBranchDropdown = async () => {
    try {
      const response = await BranchService.fetchSalesDropdown();
      dispatch(loadingBranchDropdown(response));
    } catch (error) {
      console.error('Error al cargar sucursales para ventas:', error);
    }
  };

  /**
   * 🔹 Cargar la sucursal activa del usuario autenticado.
   *    Se usa una vez tras login para dejar de pedir la sucursal manualmente
   *    en pantallas donde ya no aplica seleccionarla.
   */
  const fetchMyBranch = async () => {
    try {
      const response = await BranchService.fetchMyBranch();
      dispatch(loadingMyBranch(response));
    } catch (error) {
      console.error('Error al cargar la sucursal del usuario:', error);
    }
  };

  return {
    branchDropdown,
    myBranch,
    fetchBranchDropdown,
    fetchSalesBranchDropdown,
    fetchMyBranch,
  };
};
